import React from "react"
import { RegistroJornadaSemanal } from "./RegistroJornadaSemanal";

export function JornadaSemanal({ registrosSemanales }) {

  if (registrosSemanales !== null) {
    return (
      <table id="jornadaSemanalTable">
        <thead>
          <tr>
            <th style={{textAlign: "left"}}>Trabajador</th>
            <th>Horas Totales</th>
            <th>Lunes</th>
            <th>Martes</th>
            <th>Miercoles</th>
            <th>Jueves</th>
            <th>Viernes</th>
            <th>Sabado</th>
            <th>Domingo</th>
          </tr>
        </thead>
        <tbody>
          {registrosSemanales.map((user) => (
            <tr key={user.id}>
              <td style={{textAlign: "left"}}>{user.name} {user.apellidos}</td>
              <RegistroJornadaSemanal registroUser={user} />
            </tr>
          ))}
        </tbody>
      </table>
    )
  } else return(<></>);
}
